type ViewType = "clone" | "create" | "edit";

export const VIEW = Object.freeze({
  CLONE: "clone",
  CREATE: "create",
  EDIT: "edit",
});

export function isValidViewType(viewType: ViewType): boolean {
  return Object.values(VIEW).includes(viewType);
}
